import React from "react";

// Bloc rectangulaire pulsé (effet shimmer)
function Bar({ width, height, style }) {
  return (
    <div
      style={{
        height: height || 14,
        width: width || "60%",
        background: "linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s ease-in-out infinite",
        borderRadius: 4,
        marginBottom: 8,
        ...style,
      }}
    />
  );
}

export default function SkeletonHit({ withImage }) {
  return (
    <div className="sui-result" style={{ pointerEvents: "none" }}>
      <div style={{ color: "#4f4f4f", position: "relative" }}>
        {/* Icône doctype placeholder */}
        <div style={{
          float: "right",
          width: 24, height: 24,
          background: "linear-gradient(90deg, #e6e6e6 25%, #f0f0f0 50%, #e6e6e6 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s ease-in-out infinite",
          borderRadius: 4,
        }} />

        <div className="sui-result__header">
          <div className="sui-result__title">
            <Bar width="70%" height={20} />
            <Bar width="40%" height={16} style={{ marginTop: -4 }} />
          </div>
        </div>

        <div className="sui-result__body">
          {withImage && (
            <div style={{ maxWidth: "140px", paddingLeft: "24px", paddingTop: "10px" }}>
              <div style={{
                width: "100%", aspectRatio: "1 / 1",
                background: "linear-gradient(90deg, #e6e6e6 25%, #f0f0f0 50%, #e6e6e6 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s ease-in-out infinite",
                borderRadius: 4,
              }} />
            </div>
          )}

          <ul className="sui-result__details" style={{ listStyle: "none", padding: 0 }}>
            <li><Bar width="35%" height={16} /></li>
            <li><Bar width="55%" height={13} /></li>
            <li>
              <div style={{ display: "flex", gap: 8 }}>
                <Bar width="60px" height={13} />
                <Bar width="90px" height={13} />
                <Bar width="70px" height={13} />
              </div>
            </li>
          </ul>
        </div>

        <div style={{ textAlign: "right", marginTop: 8 }}>
          <Bar width="100px" height={11} style={{ marginLeft: "auto" }} />
        </div>
      </div>
    </div>
  );
}
